import React, { useContext } from 'react'
import { Card, Button, Row, Col, Typography } from 'antd'
import { useIntl } from 'react-intl'

import { getRechargeTypeInfo } from '../../util/recharge-type-info'
import { ThemeContext } from '../../context/themeContext'
import { DARK_THEME } from '@vacationtracker/shared/constants/ThemeSetting'
import { useAppSelector } from '../../store/hooks'
import { selectUserIdSlice } from '../../store/user-id-slice'
import { selectAuthCompanySlice } from '../../store/auth-company-slice'
import { rechargeTypeTracking } from './services/rechargeTypeTracking'

import IntlMessages from '../../util/IntlMessages'

import { RechargeType } from '@vacationtracker/shared/types/recharge-type'

import './styles.less'

const { Title, Text } = Typography

interface RechargeTypePromptProps {
  onTakeQuiz: () => void
}

const rechargeTypeCards = [
  {
    type: RechargeType.SOCIAL_SPRINTER,
    label: 'rechargeType.prompt.card.socialSprinter',
  },
  {
    type: RechargeType.STRUCTURED_SOCIALIZER,
    label: 'rechargeType.prompt.card.structuredSocializer',
  },
  {
    type: RechargeType.SPONTANEOUS_SOLOIST,
    label: 'rechargeType.prompt.card.spontaneousSoloist',
  },
  {
    type: RechargeType.DEEP_RESTORER,
    label: 'rechargeType.prompt.card.deepRestorer',
  },
]

export const RechargeTypePrompt: React.FC<RechargeTypePromptProps> = ({ onTakeQuiz }) => {
  const { formatMessage } = useIntl()
  const { theme } = useContext(ThemeContext)
  const isDark = theme === DARK_THEME
  const { userId } = useAppSelector(selectUserIdSlice)
  const { authCompany } = useAppSelector(selectAuthCompanySlice)

  return (
    <div className="recharge-type-prompt-container">
      <Card
        className={`recharge-type-prompt ${isDark ? 'dark' : ''}`}
        onMouseEnter={() => {
          if (userId && authCompany?.id) {
            rechargeTypeTracking.trackQuizPromptHovered({
              userId,
              companyId: authCompany.id,
              source: 'app/leaves/request-leave',
            })
          }
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <Title level={3} className="prompt-title">
            <IntlMessages id="rechargeType.prompt.title" />
          </Title>
          <Text className="prompt-description">
            <IntlMessages id="rechargeType.prompt.description" />
          </Text>
        </div>

        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <Button type="primary" size="large" onClick={onTakeQuiz} className="take-quiz-btn">
            <IntlMessages id="rechargeType.prompt.button" />
          </Button>
        </div>

        <Row gutter={[16, 16]} justify="center">
          {rechargeTypeCards.map((card) => {
            const info = getRechargeTypeInfo(card.type, formatMessage)
            return (
              <Col key={card.type} xs={12} sm={6}>
                <Card className={`recharge-type-card ${isDark ? 'dark' : ''}`}>
                  <div className="card-emoji">{info.emoji}</div>
                  <Text strong className="card-label">
                    <IntlMessages id={card.label} />
                  </Text>
                </Card>
              </Col>
            )
          })}
        </Row>
      </Card>
    </div>
  )
}
